import React from 'react';

import { Nullable } from '@clearverify/types';

import {
  useVerifierStaffBillingAccessQuery,
  useVerifierStaffBillingInfoQuery,
  useVerifierStaffQuery,
  useVerifierStaffUpdateMutation,
  VerifierStaffUpdate,
} from 'src/api';

export const useVerifierStaff = (verifierStaffId: Nullable<string>) => {
  const { data: verifierStaffQueryData, loading } = useVerifierStaffQuery({
    variables: {
      id: verifierStaffId || '',
    },
    skip: !verifierStaffId,
  });

  const [verifierStaffUpdateMutation, { loading: updating }] = useVerifierStaffUpdateMutation();

  const { data: verifierStaffBillingAccessQueryData, loading: billingAccessDataLoading } =
    useVerifierStaffBillingAccessQuery({
      variables: {
        id: verifierStaffId || '',
      },
      skip: !verifierStaffId,
    });

  const { data: verifierStaffBillingInfoQueryData, loading: billingInfoDataLoading } =
    useVerifierStaffBillingInfoQuery({
      variables: {
        id: verifierStaffId || '',
      },
      skip: !verifierStaffId,
    });

  const verifierStaff = verifierStaffQueryData?.verifierStaff;
  const verifierStaffBillingAccess = verifierStaffBillingAccessQueryData?.verifierStaff;
  const verifierStaffBillingInfo = verifierStaffBillingInfoQueryData?.verifierStaff;

  const updateVerifierStaff = React.useCallback(
    async (data: VerifierStaffUpdate) => {
      if (!verifierStaffId) {
        return;
      }

      await verifierStaffUpdateMutation({
        variables: {
          where: { id: verifierStaffId },
          data,
        },
      });
    },
    [verifierStaffId, verifierStaffUpdateMutation],
  );

  return {
    verifierStaff,
    verifierStaffBillingAccess,
    verifierStaffBillingInfo,
    updateVerifierStaff,
    loading,
    billingAccessDataLoading,
    billingInfoDataLoading,
    updating,
  };
};
